<div (click)="this.close($event)"
  class="modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2"
  style="z-index: 99999; position: fixed">
  <div class="bg-noir-1 text-white w-full h-fit max-h-[650px] max-w-[500px] rounded flex flex-col fadeIn p-2 z-50">
    <p class="w-full text-center py-2 font-medium">Indices Égalim</p>
    <div class="flex w-full max-w-fit gap-2 flex-wrap mx-auto justify-center pb-2">
      @for (perf of this.perfos; track perf) {
        <div
          class="min-w-32 rounded bg-noir-2 border-noir-2-contour border-1 flex flex-col p-3 gap-2">
          <mk-circular-progress-bar [value]="perf.value" [barColor]="perf.color"></mk-circular-progress-bar>
          <p class="text-center w-full">{{ perf.name }}</p>
        </div>
      }
    </div>
  </div>
</div>
